import type { Client } from '../client';
import type { RequestOptions } from '../sdk';

export class AbstractApi {
  constructor(protected client: Client) {}
  private formatHeaders(headers: any) {
    if (headers) {
      return JSON.stringify(headers);
    }
    return '';
  }
  private formatBody(body: any) {
    const isU8Array = body instanceof Uint8Array;
    if (isU8Array) {
      return body;
    }
    return new TextEncoder().encode(JSON.stringify(body));
  }
  request<T>({
    url,
    method,
    params,
    headers = '',
    body = '',
    encrypt_body = true,
    use_token = true,
    timeout = 10000,
  }: RequestOptions) {
    const urlObj = new URL(url, location.origin);

    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        urlObj.searchParams.set(key, value as string);
      });
    }

    const origin = urlObj.origin === location.origin ? '' : urlObj.origin;

    return this.client
      .invoke('http', [
        `${origin}${urlObj.pathname}${urlObj.search}`,
        method,
        this.formatHeaders(headers),
        this.formatBody(body),
        encrypt_body,
        use_token,
        BigInt(timeout),
        0,
      ])
      .then((res: any) => {
        // TODO amo
        // if (res.code && res.code !== 1) {
        //   throw res;
        // }
        return res;
      }) as unknown as Promise<T>;
  }
}
